// Translations PT / EN for Documento Express landing
export const translations = {
  pt: {
    nav: {
      solutions: "Soluções",
      channels: "Canais",
      differentiators: "Diferenciais",
      security: "Segurança",
      contact: "Contato",
      requestDemo: "Solicitar Demonstração",
    },
    hero: {
      badge: "COMUNICAÇÃO DIGITAL CORPORATIVA",
      titleStart: "Entrega Digital Inteligente para",
      titleAccent: "Empresas Modernas",
      description:
        "Automatize documentos, notificações oficiais e comunicações corporativas através de WhatsApp, SMS, RCS, E-mail e Voz com rastreabilidade, automação e segurança enterprise.",
      ctaPrimary: "Solicitar Demonstração",
      ctaSecondary: "Conhecer Soluções",
      metrics: [
        { value: "+10M", label: "Documentos entregues" },
        { value: "99.9%", label: "Disponibilidade operacional" },
        { value: "Multicanal", label: "WhatsApp • SMS • RCS • E-mail • Voz" },
      ],
      dashboard: {
        url: "app.documentoexpress.io / operações",
        live: "AO VIVO",
        kpiDeliveries: "Entregas",
        kpiReadRate: "Taxa de leitura",
        kpiChannels: "Canais",
        chartTitle: "Entregas de documentos",
        chartRange: "últimas 24h",
        recentDocs: "Documentos recentes",
        channelMix: "Mix de canais",
        ar: "AR ✓",
        pending: "Pendente",
        types: { holerite: "Holerite", fatura: "Fatura", oficial: "Oficial", contrato: "Contrato" },
        channels: { whatsapp: "WhatsApp", rcs: "RCS", email: "E-mail", sms: "SMS", voice: "Voz" },
      },
    },
    problems: {
      eyebrow: "OS DESAFIOS DA COMUNICAÇÃO TRADICIONAL",
      titleStart: "Sua operação ainda depende de processos",
      titleAccent: "manuais?",
      description:
        "Empresas enfrentam diariamente desafios que impactam custos, produtividade e experiência de clientes e colaboradores.",
      items: [
        {
          title: "Falta de rastreabilidade",
          desc: "Documentos enviados sem registro de entrega, leitura ou histórico auditável.",
        },
        {
          title: "Comunicação descentralizada",
          desc: "Canais isolados — e-mail, telefone, papel — sem visão unificada.",
        },
        {
          title: "Baixa taxa de leitura",
          desc: "Mensagens importantes ignoradas em meio a ruído e SPAM.",
        },
        {
          title: "Dependência de processos físicos",
          desc: "Impressão, correio e protocolo manual consumindo tempo e recursos.",
        },
        {
          title: "Processos demorados",
          desc: "Fluxos manuais que poderiam ser automatizados em segundos.",
        },
        {
          title: "Alto custo operacional",
          desc: "Equipes inteiras dedicadas a tarefas repetitivas de comunicação.",
        },
      ],
    },
    solutions: {
      eyebrow: "UMA PLATAFORMA. MÚLTIPLAS SOLUÇÕES.",
      title: "Soluções completas para cada necessidade da sua empresa.",
      subtitle: "Clique em uma solução para conhecer todos os detalhes.",
      cardLabel: "Ver solução",
      drawer: {
        whatIs: "O que é",
        features: "Funcionalidades",
        channels: "Canais disponíveis",
        benefits: "Benefícios",
        cta: "Solicitar demonstração desta solução",
      },
      items: [
        {
          id: "documento-express",
          tag: "Core",
          name: "Documento Express",
          short:
            "Entrega digital inteligente de documentos corporativos com rapidez e organização.",
          what:
            "Plataforma central de envio digital de documentos. Gerencie, distribua e organize comunicações documentais em escala enterprise com rastreabilidade ponta a ponta.",
          features: [
            "Envio massivo de documentos",
            "Templates corporativos reutilizáveis",
            "Agendamento e disparos programados",
            "Painel de gestão centralizado",
            "Logs detalhados de cada envio",
          ],
          channels: ["WhatsApp", "SMS", "RCS", "E-mail", "Voz"],
          benefits: [
            "Reduz custos com impressão e correio",
            "Aumenta velocidade de entrega",
            "Padroniza a comunicação corporativa",
          ],
        },
        {
          id: "documento-express-ar",
          tag: "Comprovação",
          name: "Documento Express AR",
          short:
            "Entrega digital com comprovação eletrônica de recebimento e leitura.",
          what:
            "Versão com Aviso de Recebimento digital. Cada documento gera protocolo eletrônico auditável de entrega, leitura e confirmação — substituindo o AR físico dos correios.",
          features: [
            "Envio com comprovação digital",
            "Registro de leitura em tempo real",
            "Rastreamento ponta a ponta",
            "Protocolos digitais auditáveis",
            "Histórico imutável para compliance",
          ],
          channels: ["WhatsApp", "SMS", "RCS", "E-mail"],
          benefits: [
            "Validade jurídica e auditável",
            "Substituição do AR físico",
            "Redução de até 90% em custos postais",
          ],
        },
        {
          id: "fatura-digital",
          tag: "Financeiro",
          name: "Fatura Digital",
          short:
            "Distribuição automatizada de boletos, faturas e documentos financeiros.",
          what:
            "Solução especializada em comunicação financeira. Envie boletos, faturas, segundas vias e notificações de cobrança em escala com inteligência multicanal.",
          features: [
            "Envio automatizado de boletos",
            "Régua de cobrança inteligente",
            "Segunda via on-demand via canal",
            "Integração com ERPs e sistemas de cobrança",
            "Confirmação de pagamento em tempo real",
          ],
          channels: ["WhatsApp", "SMS", "RCS", "E-mail"],
          benefits: [
            "Aumento expressivo em taxa de pagamento",
            "Redução de inadimplência",
            "Experiência moderna para o pagador",
          ],
        },
        {
          id: "documento-express-oficial",
          tag: "Institucional",
          name: "Documento Express Oficial",
          short:
            "Comunicação institucional e operacional em larga escala e com segurança.",
          what:
            "Plataforma para comunicações oficiais — comunicados internos, avisos regulatórios, notificações institucionais — com segurança enterprise e escalabilidade massiva.",
          features: [
            "Comunicados em larga escala",
            "Aprovação e workflow institucional",
            "Camadas avançadas de segurança",
            "Segmentação corporativa",
            "Relatórios executivos consolidados",
          ],
          channels: ["WhatsApp", "SMS", "RCS", "E-mail", "Voz"],
          benefits: [
            "Comunicação oficial padronizada",
            "Compliance e segurança operacional",
            "Velocidade em comunicações críticas",
          ],
        },
        {
          id: "documento-express-rh",
          tag: "RH",
          name: "Documento Express RH",
          short:
            "Gestão automatizada de holerites, contracheques e documentos trabalhistas.",
          what:
            "Solução dedicada para o RH. Distribuição automatizada de holerites, informe de rendimentos, contratos, comunicados e documentos trabalhistas, com privacidade e auditoria.",
          features: [
            "Distribuição automática de holerites",
            "Documentos trabalhistas digitalizados",
            "Assinatura e aceite eletrônico",
            "Confidencialidade por colaborador",
            "Compliance LGPD",
          ],
          channels: ["WhatsApp", "E-mail", "SMS"],
          benefits: [
            "Elimina impressão e distribuição manual",
            "Experiência moderna para colaboradores",
            "Auditoria completa por colaborador",
          ],
        },
      ],
    },
    channels: {
      eyebrow: "COMUNICAÇÃO MULTICANAL INTEGRADA",
      title: "Conecte-se com seu público pelos canais que eles realmente usam.",
      subtitle:
        "Mais alcance, mais entrega, mais resultados. Uma única plataforma orquestrando WhatsApp, SMS, RCS, E-mail e Voz com fallback inteligente entre canais.",
    },
    differentiators: {
      eyebrow: "DIFERENCIAIS ESTRATÉGICOS",
      title: "Infraestrutura robusta para operações enterprise.",
      subtitle:
        "Construído para volumes massivos, com a confiabilidade que operações críticas exigem.",
      items: [
        {
          title: "Rastreabilidade completa",
          desc: "Cada documento auditado do envio ao recebimento.",
        },
        {
          title: "Segurança operacional",
          desc: "Criptografia, LGPD e controles de acesso enterprise.",
        },
        {
          title: "APIs de integração",
          desc: "REST, Webhooks e SDKs para integração com qualquer sistema.",
        },
        {
          title: "Automação inteligente",
          desc: "Fluxos, regras e fallback automático entre canais.",
        },
        {
          title: "Escalabilidade enterprise",
          desc: "Milhões de envios mensais com baixa latência.",
        },
        {
          title: "Gestão centralizada",
          desc: "Painel único para toda a comunicação corporativa.",
        },
      ],
    },
    security: {
      title: "Segurança e conformidade no DNA da plataforma.",
      items: [
        { label: "LGPD", desc: "Conformidade total" },
        { label: "ISO 27001", desc: "Padrão internacional" },
        { label: "SOC 2", desc: "Controles auditados" },
        { label: "TLS 1.3", desc: "Criptografia em trânsito" },
        { label: "AES-256", desc: "Criptografia em repouso" },
        { label: "99.9%", desc: "SLA operacional" },
      ],
    },
    cta: {
      title: "Transforme sua comunicação digital corporativa.",
      description:
        "Centralize documentos, notificações e comunicações oficiais em uma plataforma moderna, segura e escalável.",
      primary: "Solicitar Demonstração",
      secondary: "Falar com Especialista",
    },
    footer: {
      description:
        "Plataforma de Comunicação Digital e Entrega Inteligente para empresas que valorizam segurança, agilidade e experiência.",
      solutions: "Soluções",
      channels: "Canais",
      company: "Empresa",
      legal: "Legal",
      contact: "Fale com a gente",
      contactCta: "Falar com Especialista",
      rights: "© 2026 Documento Express. Todos os direitos reservados.",
      companyLinks: [
        "Sobre nós",
        "Diferenciais",
        "Segurança",
        "Integrações",
        "Contato",
      ],
      legalLinks: ["Política de Privacidade", "Termos de Uso"],
    },
    toast: {
      requested: "Solicitação enviada — em breve nosso time entrará em contato.",
    },
  },
  en: {
    nav: {
      solutions: "Solutions",
      channels: "Channels",
      differentiators: "Why us",
      security: "Security",
      contact: "Contact",
      requestDemo: "Request a Demo",
    },
    hero: {
      badge: "ENTERPRISE DIGITAL COMMUNICATIONS",
      titleStart: "Intelligent Digital Delivery for",
      titleAccent: "Modern Enterprises",
      description:
        "Automate documents, official notifications and corporate communications across WhatsApp, SMS, RCS, E-mail and Voice with enterprise-grade traceability, automation and security.",
      ctaPrimary: "Request a Demo",
      ctaSecondary: "Explore Solutions",
      metrics: [
        { value: "+10M", label: "Documents delivered" },
        { value: "99.9%", label: "Operational uptime" },
        { value: "Omnichannel", label: "WhatsApp • SMS • RCS • E-mail • Voice" },
      ],
      dashboard: {
        url: "app.documentoexpress.io / operations",
        live: "LIVE",
        kpiDeliveries: "Deliveries",
        kpiReadRate: "Read rate",
        kpiChannels: "Channels",
        chartTitle: "Document deliveries",
        chartRange: "last 24h",
        recentDocs: "Recent documents",
        channelMix: "Channel mix",
        ar: "AR ✓",
        pending: "Pending",
        types: { holerite: "Payslip", fatura: "Invoice", oficial: "Official", contrato: "Contract" },
        channels: { whatsapp: "WhatsApp", rcs: "RCS", email: "E-mail", sms: "SMS", voice: "Voice" },
      },
    },
    problems: {
      eyebrow: "TRADITIONAL COMMUNICATION CHALLENGES",
      titleStart: "Is your operation still relying on",
      titleAccent: "manual processes?",
      description:
        "Companies face daily challenges that impact cost, productivity and the experience of customers and employees.",
      items: [
        {
          title: "Lack of traceability",
          desc: "Documents sent with no record of delivery, read receipts or audit trail.",
        },
        {
          title: "Decentralised communication",
          desc: "Isolated channels — email, phone, paper — with no unified view.",
        },
        {
          title: "Low read rate",
          desc: "Critical messages buried in noise and spam.",
        },
        {
          title: "Paper-based dependencies",
          desc: "Printing, postal mail and manual protocols draining time and budget.",
        },
        {
          title: "Slow workflows",
          desc: "Manual flows that could be automated in seconds.",
        },
        {
          title: "High operating cost",
          desc: "Entire teams dedicated to repetitive communication work.",
        },
      ],
    },
    solutions: {
      eyebrow: "ONE PLATFORM. MULTIPLE SOLUTIONS.",
      title: "Complete solutions for every need in your enterprise.",
      subtitle: "Click a solution to explore the full details.",
      cardLabel: "View solution",
      drawer: {
        whatIs: "What it is",
        features: "Features",
        channels: "Available channels",
        benefits: "Benefits",
        cta: "Request a demo of this solution",
      },
      items: [
        {
          id: "documento-express",
          tag: "Core",
          name: "Documento Express",
          short:
            "Intelligent digital delivery of corporate documents with speed and order.",
          what:
            "The central platform for digital document delivery. Manage, distribute and organise document-based communications at enterprise scale with end-to-end traceability.",
          features: [
            "Mass document delivery",
            "Reusable corporate templates",
            "Scheduling and timed broadcasts",
            "Centralised management console",
            "Detailed logs per delivery",
          ],
          channels: ["WhatsApp", "SMS", "RCS", "E-mail", "Voice"],
          benefits: [
            "Cuts printing & postal costs",
            "Boosts delivery speed",
            "Standardises corporate communication",
          ],
        },
        {
          id: "documento-express-ar",
          tag: "Proof",
          name: "Documento Express AR",
          short:
            "Digital delivery with electronic receipt and read confirmation.",
          what:
            "Digital Acknowledgement of Receipt. Every document generates an auditable electronic protocol for delivery, read and confirmation — replacing physical postal AR.",
          features: [
            "Delivery with digital proof",
            "Real-time read receipts",
            "End-to-end tracking",
            "Auditable digital protocols",
            "Immutable history for compliance",
          ],
          channels: ["WhatsApp", "SMS", "RCS", "E-mail"],
          benefits: [
            "Legally valid and auditable",
            "Replaces physical AR",
            "Up to 90% lower postal cost",
          ],
        },
        {
          id: "fatura-digital",
          tag: "Finance",
          name: "Fatura Digital",
          short:
            "Automated distribution of bills, invoices and financial documents.",
          what:
            "Built for financial communication. Send bills, invoices, duplicates and collection notices at scale with omnichannel intelligence.",
          features: [
            "Automated billing delivery",
            "Smart collection workflows",
            "On-demand duplicates via channel",
            "ERP & collections integrations",
            "Real-time payment confirmation",
          ],
          channels: ["WhatsApp", "SMS", "RCS", "E-mail"],
          benefits: [
            "Higher payment conversion",
            "Lower delinquency rate",
            "Modern payer experience",
          ],
        },
        {
          id: "documento-express-oficial",
          tag: "Official",
          name: "Documento Express Oficial",
          short:
            "Institutional and operational communication at scale, with security.",
          what:
            "Platform for official communications — internal notices, regulatory advisories, institutional notifications — with enterprise security and massive scale.",
          features: [
            "Large-scale broadcasts",
            "Institutional approval workflows",
            "Advanced security layers",
            "Corporate segmentation",
            "Consolidated executive reports",
          ],
          channels: ["WhatsApp", "SMS", "RCS", "E-mail", "Voice"],
          benefits: [
            "Standardised official communications",
            "Compliance and operational security",
            "Speed in critical broadcasts",
          ],
        },
        {
          id: "documento-express-rh",
          tag: "HR",
          name: "Documento Express RH",
          short:
            "Automated delivery of payslips, statements and labour documents.",
          what:
            "Built for HR. Automated distribution of payslips, income statements, contracts, notices and labour documents with privacy and audit.",
          features: [
            "Automatic payslip delivery",
            "Digitised labour documents",
            "Electronic signature and acceptance",
            "Confidentiality per employee",
            "Privacy regulation compliance",
          ],
          channels: ["WhatsApp", "E-mail", "SMS"],
          benefits: [
            "Eliminates printing & manual handoff",
            "Modern employee experience",
            "Full audit trail per employee",
          ],
        },
      ],
    },
    channels: {
      eyebrow: "INTEGRATED OMNICHANNEL COMMUNICATION",
      title: "Reach your audience on the channels they actually use.",
      subtitle:
        "More reach, more delivery, more results. A single platform orchestrating WhatsApp, SMS, RCS, E-mail and Voice with intelligent fallback between channels.",
    },
    differentiators: {
      eyebrow: "STRATEGIC DIFFERENTIATORS",
      title: "Robust infrastructure for enterprise operations.",
      subtitle:
        "Built for massive volumes, with the reliability that critical operations demand.",
      items: [
        {
          title: "Full traceability",
          desc: "Every document audited from send to receipt.",
        },
        {
          title: "Operational security",
          desc: "Encryption, privacy compliance and enterprise access controls.",
        },
        {
          title: "Integration APIs",
          desc: "REST, Webhooks and SDKs to integrate with any system.",
        },
        {
          title: "Intelligent automation",
          desc: "Flows, rules and automatic channel fallback.",
        },
        {
          title: "Enterprise scale",
          desc: "Millions of monthly deliveries with low latency.",
        },
        {
          title: "Centralised management",
          desc: "One console for all corporate communication.",
        },
      ],
    },
    security: {
      title: "Security and compliance built into the platform.",
      items: [
        { label: "LGPD", desc: "Full compliance" },
        { label: "ISO 27001", desc: "International standard" },
        { label: "SOC 2", desc: "Audited controls" },
        { label: "TLS 1.3", desc: "In-transit encryption" },
        { label: "AES-256", desc: "At-rest encryption" },
        { label: "99.9%", desc: "Operational SLA" },
      ],
    },
    cta: {
      title: "Transform your corporate digital communication.",
      description:
        "Centralise documents, notifications and official communications in a modern, secure and scalable platform.",
      primary: "Request a Demo",
      secondary: "Talk to a Specialist",
    },
    footer: {
      description:
        "Digital Communication and Intelligent Delivery platform for enterprises that value security, agility and experience.",
      solutions: "Solutions",
      channels: "Channels",
      company: "Company",
      legal: "Legal",
      contact: "Get in touch",
      contactCta: "Talk to a Specialist",
      rights: "© 2026 Documento Express. All rights reserved.",
      companyLinks: [
        "About us",
        "Why us",
        "Security",
        "Integrations",
        "Contact",
      ],
      legalLinks: ["Privacy Policy", "Terms of Use"],
    },
    toast: {
      requested: "Request received — our team will contact you shortly.",
    },
  },
};
